import { useState } from 'react';
import { KColorValue } from "@feature/kcolor/kcolor-input";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import {KColorComputationResult} from "@feature/kcolor/types";


export const useComputeKColor = (fromPriceList: boolean = false, publicMode=false) => {
  const [loading, setLoading] = useState(false);
  const countryApiRequest = useCountryAxiosInstance();

  const recompute = async (
    kColor: KColorValue,
    surveyId?: number, // Optional, unused for price list case
  ) => {
    setLoading(true);
    try {
      const payload: any = {
        color: kColor.color?.code,
        product_id: kColor.kColorProduct?.id,
        product: kColor.kColorProduct?.cod_prod_comm,
        min_qty: kColor.productPackage,
        form: fromPriceList ? kColor : undefined,
        from_price_list: fromPriceList,
        edit_id: fromPriceList ? kColor.edit_id : undefined,
        surveyId: !fromPriceList ? surveyId : undefined,
      };
      // Make API call to backend to compute kcolor results
      return (await countryApiRequest!.post("/kcolors/compute", payload, {...publicMode ? {publicRequest: true} : {}})) as KColorComputationResult;
    }
    finally {
      setLoading(false);
    }
  };

  return { loading, recompute }
};